__webpack_require__.p = "/palace/";